import http from 'axios'
import { formatFiltresToAxiosParams } from './utils/filtres.utils'

export default {
  // carte évolution du rendement (numtiers)
  getRendementsByNumtiersAndRecolteAndGraine: (username, anneeRecolte, codeGraine) => {
    return http.get(`/web/v1/${username}/culture/rendement?anneeRecolte=${anneeRecolte}&codeGraine=${codeGraine}`)
  },
  // carte évolution du rendement (groupe)
  getRendementsByNumtiersAndRecolteAndGraineGroupe: (username, anneeRecolte, codeGraine, filtres) => {
    let route = `/web/v1/${username}/culture/rendement/groupe?anneeRecolte=${anneeRecolte}&codeGraine=${codeGraine}`
    route += `&${formatFiltresToAxiosParams(filtres)}`
    return http.get(route)
  },
  //carte mon rendement moyen
  getEvolutionRendement: (username, anneeRecolte, codeTypeCulture) => {
    return http.get(`/web/v1/${username}/culture/${anneeRecolte}/rendement/evolution?codeTypeCulture=${codeTypeCulture}`)
  },
  //jauge mon rendement moyen
  getResumeRepartitionParQuartileRendementGroupe: (username, anneeRecolte, codeTypeCulture, filtres) => {
    let route = `/web/v1/${username}/culture/${anneeRecolte}/rendement/groupe?codeTypeCulture=${codeTypeCulture}`
    route += `&${formatFiltresToAxiosParams(filtres)}`
    return http.get(route)
  },
  getGrapheComparaisonCultureRendementMoyens: (username, anneeRecolte, codeTypeCulture, filtres) => {
    let route = `/web/v1/${username}/culture/${anneeRecolte}/rendement/comparaison?codeTypeCulture=${codeTypeCulture}`
    route += `&${formatFiltresToAxiosParams(filtres)}`
    return http.get(route)
  }
}
